import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import useResourceCode from 'stores/useResourceCode';

const withPermissions =
  (allowResourceCode: string | string[]) => (WrappedComment: React.ComponentClass | React.FC) => {
    return (props: { children?: React.ReactNode }) => {
      // const { path } = useRouteMatch();
      const { hasFetchedResourceCodes, resourceCodes } = useResourceCode();
      const history = useHistory();
      // console.log('该路由需要的权限--', allowResourceCode);
      // console.log('登录用户有的权限', resourceCodes);
      // console.log(
      //   '登录用户是否可以访问当前路由',
      //   resourceCodes.some(item => item.code === allowResourceCode)
      // );
      useEffect(() => {
        // redirect to a different page or display a message indicating the user do't have access
        const hasAuth = resourceCodes.some(item => {
          if (Array.isArray(allowResourceCode)) {
            return allowResourceCode.includes(item.code);
          } else {
            return item.code === allowResourceCode;
          }
        });
        if (hasFetchedResourceCodes && !hasAuth) {
          // 跳转无权限页面
          history.replace('/noAuth');
        }
      }, [allowResourceCode, hasFetchedResourceCodes]);

      return <WrappedComment {...props} />;
    };
  };

export default withPermissions;
